<a id="filter-link" class="filter-link" (click)="togglePlotChartSidebar()" [ngClass]="{ active: globalData.applicationState.plotChartSidebarOpen }">
  <mat-icon svgIcon="graph-filter"></mat-icon>
</a>
